/**
 * Shared by the Send Quote and Send Invoice dialogs.
 *
 * `GET /admin/quotations/{id}/recipients` returns contacts across every client
 * organisation the seller can see — not only the one on this quote's billing
 * address — already ordered with the billed org first and the rest
 * alphabetically. This collapses that flat list into <optgroup>s without
 * disturbing the order the server chose.
 */
// eslint-disable-next-line import/prefer-default-export
export const groupByOrg = (list) => {
  const groups = [];
  const byId = new Map();
  (list || []).forEach((r) => {
    const id = r.organizationId ?? 0;
    if (!byId.has(id)) {
      const group = {
        id,
        name: r.organizationName || "Unknown organisation",
        isQuoteCustomer: Boolean(r.isQuoteCustomer),
        people: [],
      };
      byId.set(id, group);
      groups.push(group);
    }
    byId.get(id).people.push(r);
  });
  return groups;
};
